import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CoreModule } from '@core/core.module';
import { HelpersModule } from '@core/components/helpers/helpers.module';


import { ProjectDetailsInfoAttachmentsComponent } from './main/main.component';
import { ProjectDetailsInfoAttachmentsListComponent } from './list/list.component';
import { ProjectDetailsInfoAttachmentsUploadComponent } from './upload/upload.component';
import { FilesListModule } from '@core/components/files/lists/lists.module';
import { CoreStorageModule } from '@core/components/storage/storage.module';
import { SignedFilesModule } from '@core/components/signed-files/signed-files.module';


@NgModule({
    imports: [
        CommonModule,
        FilesListModule,
        CoreModule,
        HelpersModule,
        CoreStorageModule,
        SignedFilesModule
    ],
    schemas: [ CUSTOM_ELEMENTS_SCHEMA ],
    declarations: [
        ProjectDetailsInfoAttachmentsComponent,
        ProjectDetailsInfoAttachmentsListComponent,
        ProjectDetailsInfoAttachmentsUploadComponent
        
    ],
    exports: [
        ProjectDetailsInfoAttachmentsComponent
    ],

})
export class ProjectsDetailsInfoAttachmentModule { }
